import React, { useRef } from "react";
import { IoMdPrint } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { useState,useEffect } from "react";

const StaffProfile = () => {
 
  const navigate=useNavigate();
  const location=useLocation();
const {staff_id}=useParams();
const {data}=location.state
console.log(staff_id,"idddddd")
console.log(data,"uy")
    const [role, setRole] = useState("");
 console.log("sal",data.salary)

  const print = () => {
    window.print();
  };
  const handleNavigate = () => {
     
      navigate("/staffattendance");
  
  };
  


  
    useEffect(() => {
      const sessionStr = sessionStorage.getItem("user-info");
      if (sessionStr) {
        const session = JSON.parse(sessionStr);
        setRole(session.user.role);
        // setUserName(session.user.name);
        // setCompanyID(session.user.company_id || "");
        // setLocationID(session.user.location_id || "");
        
       
      } else {
        navigate("/login");
      }
    }, [navigate]);
  
  

  

  const design = 'w-full bg-gx-surface rounded-gx p-2 border border-gx-border'

  return (
 
   
    <div className="bg-gx-canvas px-10">
       <div className="flex justify-between items-center ">
        <div>
            <IoArrowBack onClick={handleNavigate}
              className="cursor-pointer text-3xl print:hidden"/>
        </div>
        <div className="print:m-0">
            <IoMdPrint
              className="text-4xl cursor-pointer print:hidden"
              onClick={print}
            />
        </div>
       </div>

       <h1 className="text-2xl font-bold my-3">Staff Profile:</h1>
     

      <div className="bg-gx-canvas overflow-visible print:overflow-visible">
        <div className="flex justify-between items-center">
          <div className="w-full md:w-full p-4 rounded-lg ">
            <div className="mb-0">
              <h2 className="text-xl font-bold mb-4">Personal Information</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                <div className="w-full">
                  <label className="block font-medium mb-1">Full Name</label>
                  <div className={design}>
                    <p>{data.name}</p>
                  </div>
                </div>

                <div>
                  <label className="block font-medium mb-1">Phone Number</label>
                  <div className={design}>
                    <p>{data.phone_number}</p>
                  </div>
                </div>
                
                <div>
                  <label className="block font-medium mb-1">
                    Email Address
                  </label>
                  <div className={design}>
                    <p>{data.email}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-gx-canvas rounded-lg print:bg-white mt-0 p-2">
          <h2 className="text-xl font-bold mb-4">Additional Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 print:gap-12">
            <div className="break-inside-avoid">
              <label className="block font-medium mb-1">Address</label>
              <div className={design}>
                <p>{data.address}</p>
              </div>
            </div>
            
            <div className="break-inside-avoid">
              <label className="block font-medium mb-1">Salary</label>
              <div className={design}>
                <p>{data. salary}</p>
              </div>
            </div>
         
            <div className="break-inside-avoid">
              <label className="block font-medium mb-1">
                HireDate
              </label>
              <div  className={design}>
                <p>{data.hire_date}</p>
              </div>
            </div>
           
            <div className="break-inside-avoid">
              <label className= "block font-medium mb-1">
                Employement Status
              </label>
              <div className={design}>
                <p>{data.employment_status}</p>
              </div>
            </div>
            
       
        
            <div className="break-inside-avoid">
              <label className="block font-medium mb-1">Work Schedule</label>
              <div className={design}>
                <p>{data.work_schedule}</p>
              </div>
            </div>
          

       
            <div className="break-inside-avoid">
              <label className="block font-medium mb-1">Additional Notes</label>
              <div className={design}>
                {data.additional_notes}
              </div>
            </div>
        
  
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffProfile;
